import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getMFSearch(data);
    }
}
export default MFSearchUseCase;
